export function getQualityColor(quality: string): { bg: string; text: string; border: string } {
  switch (quality) {
    case "best":
      return {
        bg: "rgba(22, 163, 74, 0.08)",
        text: "var(--color-success)",
        border: "rgba(22, 163, 74, 0.2)",
      };
    case "good":
      return {
        bg: "rgba(22, 163, 74, 0.05)",
        text: "var(--color-success-text)",
        border: "rgba(22, 163, 74, 0.15)",
      };
    case "neutral":
      return {
        bg: "rgba(217, 119, 6, 0.06)",
        text: "var(--color-warning)",
        border: "rgba(217, 119, 6, 0.2)",
      };
    case "bad":
      return {
        bg: "rgba(220, 38, 38, 0.05)",
        text: "var(--color-error)",
        border: "rgba(220, 38, 38, 0.15)",
      };
    default:
      return { bg: "transparent", text: "inherit", border: "transparent" };
  }
}

export function getQualityLabel(quality: string, language: "en" | "hi" = "en"): string {
  if (language === "hi") return QUALITY_LABELS_HI[quality] ?? "";
  switch (quality) {
    case "best":
      return "Best";
    case "good":
      return "Good";
    case "neutral":
      return "Neutral";
    case "bad":
      return "Bad";
    default:
      return "";
  }
}

const QUALITY_LABELS_HI: Record<string, string> = {
  best: "उत्तम",
  good: "शुभ",
  neutral: "सामान्य",
  bad: "अशुभ",
};

export function formatDate(date: Date, locale = "en-IN"): string {
  return date.toLocaleDateString(locale, {
    weekday: "long",
    year: "numeric",
    month: "long",
    day: "numeric",
  });
}

export function toDateString(date: Date): string {
  const y = date.getFullYear();
  const m = String(date.getMonth() + 1).padStart(2, "0");
  const d = String(date.getDate()).padStart(2, "0");
  return `${y}-${m}-${d}`;
}
